// White GAA football icon, drawn in a 0..100 box for nesting into any SVG.
export function GaaBallShape({ stroke = "#B8C2CE", fill = "#FFFFFF" }) {
  const w = 4;
  return (
    <g fill="none" stroke={stroke} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="50" cy="50" r="45" fill={fill} />
      {/* barrel side seams */}
      <path d="M30,12 Q13,50 30,88" />
      <path d="M70,12 Q87,50 70,88" />
      {/* horizontal panel lines */}
      <line x1="15" y1="37" x2="85" y2="37" />
      <line x1="15" y1="63" x2="85" y2="63" />
      {/* GAA swoosh */}
      <path d="M36,53 Q41,44 46,52 Q50,58 54,52 Q59,44 64,53" strokeWidth={w * 0.9} />
    </g>
  );
}


export default function GaaBallIcon({ size = 20, className, stroke, fill }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className}>
      <GaaBallShape stroke={stroke} fill={fill} />
    </svg>
  );
}
